import React from "react";
import {List, ListItem} from "@mui/material";
import FormLink from "./FormLink";
import {Instrument} from "../../gen/api";
import GridPaper from "../ContentBox/GridPaper";
import FileDownload from "../Files/FileDownload";

type Props = {
  instrument: Instrument
}

export default function Downloads({instrument}: Props) {
  return (
      <GridPaper title="Downloads">
        <List>
          {instrument.downloadLinks?.map(link =>
              <ListItem key={link.id}>
                <FormLink downloadLink={link}/>
              </ListItem>
          )}

          {instrument.forms?.map(form =>
              <ListItem key={form.id}>
                <FileDownload form={form}/>
              </ListItem>)
          }
        </List>
      </GridPaper>
  );
}